/**
 * ContractsDetail -- Extracted from DetailPage.jsx (A12 Sprint 1).
 *
 * Shows contracts grouped by type with expiry countdown.
 * Smallest-first extraction per Cross-Block Pattern 4.
 */

import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { apiClient } from '../../lib/apiClient';

export default function ContractsDetail({ token }) {
  const { t } = useTranslation();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!token) return;
    apiClient.get('/api/v1/aif/farm/contracts')
      .then(d => setData(d))
      .catch(() => {});
  }, [token]);

  if (!data?.contracts?.length) {
    return (
      <div className="flex flex-col items-center justify-center h-48 text-center px-4">
        <div className="text-3xl mb-3">&#x1F4C4;</div>
        <p className="text-sm text-[var(--aif-text-muted)] max-w-[250px] leading-relaxed">
          {t('contracts.noContracts')}
        </p>
      </div>
    );
  }

  const grouped = {};
  data.contracts.forEach(c => {
    const type = c.contract_type || 'OTHER';
    if (!grouped[type]) grouped[type] = [];
    grouped[type].push(c);
  });

  const today = new Date();
  return (
    <div className="space-y-4">
      {Object.entries(grouped).map(([type, contracts]) => (
        <div key={type}>
          <h3 className="text-xs font-semibold text-[var(--aif-text-secondary)] mb-2 uppercase tracking-wide">
            {t(`contracts.${type}`)}
          </h3>
          <div className="space-y-2">
            {contracts.map((c, i) => {
              const endDate = c.end_date ? new Date(c.end_date) : null;
              const daysLeft = endDate ? Math.ceil((endDate - today) / 86400000) : null;
              return (
                <div key={i} className="rounded-xl border border-[var(--aif-border-default)] bg-[var(--aif-bg-surface)] p-3">
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-medium text-[var(--aif-text-primary)]">
                      {c.counterparty_name || c.description || type}
                    </span>
                    {c.payment_amount && (
                      <span className="text-xs font-semibold text-[var(--aif-text-primary)]">
                        {c.payment_amount} {c.payment_currency}
                      </span>
                    )}
                  </div>
                  <div className="flex items-center gap-2 mt-1 text-xs text-[var(--aif-text-muted)]">
                    {endDate && (
                      <span className={daysLeft !== null && daysLeft < 90 ? 'text-orange-400 font-medium' : ''}>
                        bis {c.end_date} {daysLeft !== null && daysLeft > 0 ? `(${daysLeft} ${t('contracts.daysLeft')})` : ''}
                      </span>
                    )}
                    {c.payment_frequency && <span>| {c.payment_frequency}</span>}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
